import type { Btc15PredictorResponse } from './btc15Types';

// A display-only staleness threshold for this read-only page. This is
// intentionally looser than the automation worker's future 10s order-entry
// data-age gate (plan section 8) — that gate protects against placing an
// order on stale data, not against showing an informational number. The
// data age is measured from the latest 1-minute candle, so it runs from 0 to
// about 60s in normal operation; past 90s a candle has been missed.
const STALE_DATA_AGE_MS = 90_000;

/** Whether the predictor's Coinbase data is far enough behind to warn about. */
export function isPredictorDataStale(response: Btc15PredictorResponse): boolean {
  return response.diagnostics.coinbaseDataAgeMs > STALE_DATA_AGE_MS;
}
